// src/modules/auth/auth.module.tsx
import React from "react";
import { registerModule } from "../module.register";
import { AuthProvider } from "./AuthProvider";
import { authRoutes } from "./routes/auth.routes";

const AuthModule: React.FC = () => {
  return (
    <AuthProvider>
      <div>{/* Auth module wrapper */}</div>
    </AuthProvider>
  );
};

// Register auth module with its routes
registerModule(() => ({
  name: "auth",
  component: AuthModule,
  routes: authRoutes,
}));
